import React from 'react'
import { ToastContainer as _ToastContainer } from 'react-toastify'

export const ToastContainer: React.FC = () => {
  return (
    <_ToastContainer position="top-right" autoClose={7000} closeButton={false} hideProgressBar={false} icon={false} />
  )
}
